import { useState } from 'react';
import { Pencil } from 'lucide-react';

import { Button } from 'components/ui/Button';
import { PersonneMoraleInfoCard } from 'back-office/shared/components/personnes-morales/PersonneMoraleInfoCard';
import { profileFromCorporate } from 'back-office/shared/components/personnes-morales/personneMoraleProfile';

import { CorporateDto } from '../api/corporateApi';
import { CorporateInfoForm } from './CorporateInfoForm';

interface CorporateInfoCardProps {
  plateformeId: string;
  corporate: CorporateDto;
  onSaved: () => void;
  /** 'identity' = legal section alone (carries edition); 'contact' =
      address/contact alone; default: both stacked. */
  variant?: 'full' | 'identity' | 'contact';
}

/**
 * Identity + contact card of the corporate: the read render is the shared PM
 * card (PersonneMoraleInfoCard); this layer only adds in-place edition
 * (Modifier → corporate form → Enregistrer / Annuler).
 */
export const CorporateInfoCard: React.FC<CorporateInfoCardProps> = ({
  plateformeId,
  corporate,
  onSaved,
  variant = 'full'
}) => {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <CorporateInfoForm
        plateformeId={plateformeId}
        corporate={corporate}
        onSaved={() => {
          setEditing(false);
          onSaved();
        }}
        onCancel={() => setEditing(false)}
      />
    );
  }

  const profile = profileFromCorporate(corporate);

  const editButton = (
    <Button outline color="primary" onClick={() => setEditing(true)}>
      <Pencil data-slot="icon" />
      Modifier
    </Button>
  );

  if (variant === 'identity') {
    return (
      <PersonneMoraleInfoCard
        profile={profile}
        variant="identity"
        titleAside={editButton}
      />
    );
  }
  if (variant === 'contact') {
    return <PersonneMoraleInfoCard profile={profile} variant="contact" />;
  }
  return (
    <div className="flex flex-col gap-6">
      <PersonneMoraleInfoCard
        profile={profile}
        variant="identity"
        titleAside={editButton}
      />
      <PersonneMoraleInfoCard profile={profile} variant="contact" />
    </div>
  );
};
